import { request } from './core.api';

export interface NotificationDto {
  id: string;
  type: string;
  targetUrl: string;
  createdAt: string;
  readAt?: string | null;
  data: Record<string, string | null>;
}

export interface NotificationListDto {
  unreadCount: number;
  items: NotificationDto[];
}

export const notificationsApi = {
  list: () => request<NotificationListDto>('/notifications'),
  markRead: (notificationId: string) => request<void>(`/notifications/${notificationId}/read`, { method: 'POST' }),
  markAllRead: () => request<void>('/notifications/read-all', { method: 'POST' }),
  delete: (notificationId: string) => request<void>(`/notifications/${notificationId}`, { method: 'DELETE' }),
  deleteAll: () => request<void>('/notifications', { method: 'DELETE' }),
};
